import { Button, ButtonProps } from "@chakra-ui/react";

export default function LoginLayoutButton(props: ButtonProps) {
  return (
    <Button
      size="lg"
      colorScheme="pinkButton"
      borderRadius="lg"
      py={3}
      w="100%"
      {...props}
    />
  );
}
